import React from "react";
import { HashRouter as Router, Switch, Route } from "react-router-dom";

import Planes from "./planes/Planes";
import Home from "./Home";

function App () {

	return (
		<Router>
			<Switch>
				<Route path="/" exact component={Home} />
				<Route path="/samoloty" component={Planes} />
			</Switch>
		</Router>
	);
}


export default App;